<nz-layout>
  <nz-content><ng-container>
      <app-reusable-table title="Current Problems" [columns]="[
          'Problem Diagnosis',
          'Problem',
          'Diagnosis Assertion',
          'Resolution Circumstances',
          'Start Date',
          'Status'
        ]" [rowFields]="[
          'problem',
          'problemName',
          'diagnosisAssertion',
          'resolutionCircumstancesText',
          'onSetDate',
          'statusCode'
        ]" [data]="currentProblems?.getAll" [dataGetList]="currentProblems" [expandComponent]="expandComp"
        [addComponent]="addComp" [isLoading]="isLoading" [isNoKnownLoading]="isNoKnownLoading" [deleteFun]="deleteFun"
        [stopFun]="stopFun" [handleToggleFun]="handleToggleFun" [openModalFun]="openModalFun" [isPreview]="false"
        [addPermissions]="['a-cpr']" [stopPermissions]="['s-pro']" />
    </ng-container>
  </nz-content>
</nz-layout>